import React from "react";
import HallFameContent from "../FunctionalComponents/HallFame/HallFameContent";

function HallFame() {
  return (
    <>
      <HallFameContent />
    </>
  );
}

export default HallFame;
